import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=4d29acc6"
import script from "./Attribute.vue?vue&type=script&lang=js"
export * from "./Attribute.vue?vue&type=script&lang=js"
import style0 from "./Attribute.vue?vue&type=style&index=0&id=4d29acc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../usr/local/share/.config/yarn/global/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports